import { IconInfoFilled } from "@ab.uitools/ui-library/components/SVGIcons";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { ReactNode } from "react";

interface Props {
  className?: string;
  content: string | ReactNode;
}

export const InfoContainer = ({ content, className }: Props) => {
  return (
    <div className={`info-container ${className}`}>
      <IconInfoFilled type="information-light" size="small"/>
      <Text className="pl-4">
        {content}
      </Text>
    </div>
  );
};
